export default "__VITE_PUBLIC_ASSET__bfc19cb5__"